import styled from "styled-components"

export const FeatureCardStyles = styled.section`
  .card-img-top{
    width: 43px;
  }
`
